module.exports = __webpack_public_path__ + "img/4@2x.292f2b6f.png";